// Barra de botones abajo, SOLO en el teléfono (ver App.css). En tablet y PC
// no se ve y el menú de la izquierda sigue igual.
// · items: las 3 secciones principales del perfil [{ icono, texto, valor }]
// · "Más" abre el menú completo (el mismo de la izquierda) como un panel.
export default function BarraMovil({ items, activo, onElegir, abierto, setAbierto }) {
  return (
    <>
      <div className="overlay-menu" onClick={() => setAbierto(false)} />
      <nav className="barra-movil" aria-label="Menú principal">
        {items.map((it) => (
          <button
            key={it.valor}
            className={!abierto && activo === it.valor ? "barra-btn activo" : "barra-btn"}
            onClick={() => { setAbierto(false); onElegir(it.valor); }}
          >
            <span className="barra-icono">{it.icono}</span>
            <span className="barra-texto">{it.texto}</span>
          </button>
        ))}
        <button
          className={abierto ? "barra-btn activo" : "barra-btn"}
          onClick={() => setAbierto(!abierto)}
        >
          <span className="barra-icono">{abierto ? "✕" : "☰"}</span>
          <span className="barra-texto">Más</span>
        </button>
      </nav>
    </>
  );
}
